import blogCustomTypeConfig from 'customtypes/blog/index.json';
import { BlogDocumentData } from 'prismicio-types';

export const ENABLE_CHALLENGES = !!process.env.NEXT_PUBLIC_SHOW_CHALLENGES;

export const UTILITY_PAGES = [
  {
    label: 'Help',
    path: '/help',
  },
  {
    label: 'Terms of Use',
    path: '/terms',
  },
  {
    label: 'Legal Details',
    path: '/legal',
  },
  {
    label: 'Privacy Policy',
    path: '/privacy',
  },
  {
    label: 'Cookie Policy',
    path: '/cookie-policy',
  },
  {
    label: 'Recruiting Privacy Policy',
    path: '/recruiting-privacy',
  },
  {
    label: 'Licensing',
    path: '/licensing',
  },
  {
    label: 'Publishing Designs',
    path: '/guidelines',
  },
  {
    label: 'Cancellation Policy',
    path: '/cancellation',
  },
  ...(ENABLE_CHALLENGES
    ? [
        {
          label: 'Challenge Rules',
          path: '/challenge-rules',
        },
      ]
    : []),
  {
    label: 'Contact',
    path: '/contact',
  },
];

export const SETTING_PAGES = [
  {
    label: 'Account',
    path: '/user/settings/account',
  },
  {
    label: 'Change Password',
    path: '/user/settings/password',
  },
  {
    label: 'Subscription',
    path: '/user/settings/subscription',
  },
  {
    label: 'Invite Friends',
    path: '/user/settings/referral',
  },
  {
    label: 'Earn Credits',
    path: '/earn',
  },
];

export const TEAM_SETTING_PAGES = [
  {
    label: 'Team Account',
    path: '/user/settings/account',
  },
  {
    label: 'Team Members',
    path: '/user/settings/team-members',
  },
  {
    label: 'Subscription',
    path: '/user/settings/subscription',
  },
  {
    label: 'Invite Friends',
    path: '/user/settings/referral',
  },
  {
    label: 'Earn Credits',
    path: '/earn',
  },
];

// height of the header in px
export const HEADER_HEIGHT = 72;
export const SMALL_FOOTER_HEIGHT = 30;

export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;

export const LANDING_PAGE = 'https://try.kittl.com/';

export const SORT_OPTIONS = [
  { id: 'name', label: 'Name' },
  { id: 'recent', label: 'Recent' },
  { id: 'popularity', label: 'Most used', unauthorisedDefault: true },
  { id: 'trending', label: 'Trending', default: true },
];

export const AI_FEED_TRENDING_TAGS: { id: string; label: string }[] = [
  { id: 'portrait', label: '#portrait' },
  { id: 'animals', label: '#animals' },
  { id: 'anime', label: '#anime' },
  { id: 'landscapes', label: '#landscapes' },
  { id: 'clipart', label: '#clipart' },
  { id: 'vector', label: '#vector' },
  { id: 'fantasy', label: '#fantasy' },
];

export enum AI_FEED_SORT {
  TRENDING = 'trending',
  MOST_USED = 'most_used',
  NAME = 'name',
  RECENT = 'recent',
  CREATED = 'created',
}

export interface AI_FEED_SORT_OPTION {
  id: AI_FEED_SORT;
  label: string;
  default?: boolean;
}

export const AI_FEED_SORT_OPTIONS: AI_FEED_SORT_OPTION[] = [
  { id: AI_FEED_SORT.NAME, label: 'Name' },
  { id: AI_FEED_SORT.CREATED, label: 'Recent' },
  { id: AI_FEED_SORT.MOST_USED, label: 'Most used' },
  { id: AI_FEED_SORT.TRENDING, label: 'Trending', default: true },
];

export const BLOG_CATEGORIES = blogCustomTypeConfig.json.Properties.category
  .config.options as ReadonlyArray<BlogDocumentData['category']>;

export const BLOG_CATEGORY_ALL = 'All';

export const HELP_CATEGORIES = [
  {
    label: 'Editing & Design',
    key: 'design',
    description:
      'Learn all about using the editor, adding elements or working with text and texture.',
  },
  {
    label: 'Subscription',
    key: 'subscription',
    description:
      'Find all information about subscription plans, payment and billing here.',
  },
  {
    label: 'Account Settings',
    key: 'account',
    description:
      'Here you can find information about your account and profile settings.',
  },
  {
    label: 'Licensing',
    key: 'licensing',
    description:
      'Here you can find information about what is allowed and not allowed to do with Kittl Content.',
  },
];

export const USER_DASHBOARD_TAKE = 28;
export const USER_RECENT_PROJECTS_TAKE = 10;
